module.exports = __webpack_public_path__ + "static/media/handleIndustrial.55d601ec.jpeg";